import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Web3Service } from '@/services/web3.service';

@Directive({
  standalone: true,
  selector: 'app-wallet-address'
})

export class WalletAddressDirective implements OnChanges {

  @Input() address!: string;
  @Input() maxVisibleChars: number | null = null;

  constructor(
    private el: ElementRef,
    public web3Svc: Web3Service
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['address'] || changes['maxVisibleChars']) {
      this.updateDisplayText(this.address);
    }
  }

  async getEns(el: HTMLElement, address: string): Promise<void> {
    const ens = await this.web3Svc.getEnsFromAddress(address);
    if (ens) el.innerText = ens;
  }

  private updateDisplayText(address: string | null | undefined): void {
    const el = this.el.nativeElement as HTMLElement;

    if (!address) {
      el.innerText = '';
      return;
    }

    el.innerText = this.formatAddress(address);
    this.getEns(el, address);
  }

  private formatAddress(address: string): string {
    if (address.includes('.eth')) {
      return address;
    }

    const maxChars = this.maxVisibleChars ?? 10;
    if (maxChars <= 0 || address.length <= maxChars) {
      return address;
    }

    const leading = Math.ceil(maxChars / 2);
    const trailing = Math.max(1, Math.floor(maxChars / 2));

    return `${address.substring(0, leading)}...${address.substring(address.length - trailing)}`;
  }

}
